export default __webpack_public_path__ + "static/media/Painting.2b851197.png";